export const URL_GET_LIST_INVOICE_BY_CUSTOMER = '/v1/gocheckin/invoice/site/list-by-customer?';
export const URL_SEND_INVOICE = "/v1/gocheckin/invoice/form/send-email";
